import {
  Grid,
  Box,
  Divider,
  TextField,
  FormLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import InputSelect from "../components/FormElements/InputSelect";
import InputTextOutlined from "../components/FormElements/InputTextOutlined";
import RepeaterControl from "../components/FormElements/RepeaterControl";
import { PRODEP_TITLE } from "../constants/prodep";
import { prodepStudent } from "../fieldsProdep";
import { schemaStudentSelect, schemaStudentText } from "../validations/prodep";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const TableStudentProdep = ({
  id,
  fields,
  errors,
  onHandleChange,
  onHandleRows,
}) => {
  const [students, setStudents] = useState(fields ?? []);

  const addMoreRows = () => {
    const newFields = [...students];
    newFields.push(prodepStudent);
    setStudents(newFields);
    onHandleRows(newFields);
  };

  const onChange = useCallback(
    (e, index) => {
      onHandleChange(e, index);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useMemo(() => setStudents(fields), [fields]);

  const removeRows = () => setStudents((prev) => prev.slice(0, -1));
  return (
    <Grid container spacing={2}>
      {students &&
        students.length > 0 &&
        students.map((student, index) => {
          return (
            <Fragment key={`prodep-${index}`}>
              <Grid item xs={3}>
                <InputTextOutlined
                  id={`students_${index}_matricula`}
                  size={"normal"}
                  label="Matricula del Alumno"
                  error={
                    errors &&
                    errors[index]?.matricula &&
                    errors[index].matricula.txt
                  }
                  initialValue={student.matricula}
                  onChangeInput={(e) =>
                    onChange(e, schemaStudentText(e.target.name))
                  }
                  variant="standard"
                />
              </Grid>
              <Grid item xs={9}>
                <InputTextOutlined
                  id={`students_${index}_student`}
                  size={"normal"}
                  label="Nombre del Alumno"
                  error={
                    errors &&
                    errors[index]?.student &&
                    errors[index].student.txt
                  }
                  initialValue={student.student}
                  onChangeInput={(e) =>
                    onChange(e, schemaStudentText(e.target.name))
                  }
                  variant="standard"
                />
              </Grid>

              <Grid item xs={3}>
                <InputTextOutlined
                  id={`students_${index}_title`}
                  size={"normal"}
                  label="Nombre del Tema"
                  error={
                    errors && errors[index]?.title && errors[index].title.txt
                  }
                  initialValue={student.title}
                  onChangeInput={(e) =>
                    onChange(e, schemaStudentText(e.target.name))
                  }
                  variant="standard"
                />
              </Grid>
              <Grid item xs={3}>
                <InputSelect
                  id={`students_${index}_type`}
                  label="Modalidad"
                  opts={PRODEP_TITLE}
                  placeholder=""
                  initialValue={student.type}
                  error={
                    errors && errors[index]?.type && errors[index].type.txt
                  }
                  onChangeInput={(e) =>
                    onChange(e, schemaStudentSelect(e.target.name))
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <InputTextOutlined
                  id={`students_${index}_result`}
                  size={"normal"}
                  label="Resultado"
                  error={
                    errors && errors[index]?.result && errors[index].result.txt
                  }
                  initialValue={student.result}
                  onChangeInput={(e) =>
                    onChange(e, schemaStudentText(e.target.name))
                  }
                  variant="standard"
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl
                  fullWidth
                  sx={{ textAlign: "left" }}
                  disabled={false}
                >
                  <FormLabel
                    error={errors && errors[0] && errors[0]?.date?.txt}
                    htmlFor={id}
                    sx={{ marginTop: "auto" }}
                  >
                    Fecha
                  </FormLabel>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      value={student.date === "" ? null : student.date}
                      onChange={(newValue) => {
                        const e = {
                          target: {
                            name: `students_${index}_date`,
                            value: newValue.format("YYYY-MM-DD"),
                          },
                        };
                        onChange(e, schemaStudentText(e.target.name));
                        // setValue(newValue);
                      }}
                      sx={{ paddingTop: 0 }}
                      slotProps={{
                        textField: {
                          readOnly: true,
                        },
                      }}
                      format="YYYY-MM-DD"
                    />
                  </LocalizationProvider>
                  {errors && errors[0] && errors[0]?.date?.txt && (
                    <FormHelperText error id={id}>
                      {errors[0]?.result?.txt}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }}></Divider>
              </Grid>
            </Fragment>
          );
        })}
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "end",
          }}
        >
          <RepeaterControl
            elements={students}
            maxElements={10}
            labelRemove={"Remover"}
            labelAdd={"Agregar (max 10)"}
            onHandleIncrement={addMoreRows}
            onHandleDecrement={removeRows}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default TableStudentProdep;
